import React from 'react'
import FaqHead from '../../HomePage/Faq/FaqHead'
import AttestationFaqMain from './AttestationFaqMain'
import "./../../HomePage/Faq/Faq.css";

const AttestationFaq = () => {
  return (
<div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="Attestation Services in Bangalore " />
        <AttestationFaqMain />
      </div>
    </div>
  )
}

export default AttestationFaq
